module.exports = __webpack_public_path__ + "img/banker-gold_1920.21bb95f8.png";